(function () {
  'use strict';

  // ─── CONFIG ────────────────────────────────────────────────────────────────
  const WORKER_URL  = 'https://res.cloudinary.com/dhqvlsb3l/raw/upload/assets/in/ecommerce/products/hearstore-products.json';
  const CACHE_KEY   = 'pc_prices_cache_v2';
  const CACHE_TTL   = 60 * 60 * 1000; // 1 hr browser cache

  const STORE_NAME  = 'HearStore'; // Your store name shown in the header

  // Static feature rows shown below prices — edit to match your store's USPs
  const FEATURE_ROWS = [
    { label: 'Warranty',                hearstore: '3 Years', amazon: '2 Years', flipkart: '2 Years' },
    { label: 'Free Device Protection+', hearstore: 'YES',     amazon: 'NO',      flipkart: 'NO'      },
    { label: 'Free Doorstep Services',  hearstore: 'YES',     amazon: 'YES',     flipkart: 'YES'     },
  ];
  // ──────────────────────────────────────────────────────────────────────────

  const CSS = `
    #pc-overlay {
      display: none; position: fixed; inset: 0;
      background: rgba(0,0,0,0.55); z-index: 99998;
      align-items: center; justify-content: center;
    }
    #pc-overlay.pc-open { display: flex; }

    #pc-modal {
      background: #fff;
      border-radius: 18px;
      border: 4px solid #0F1C85;
      max-width: 520px; width: 96%;
      box-shadow: 0 16px 56px rgba(0,0,0,0.24);
      position: relative;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      max-height: 90vh; overflow-y: auto; overflow-x: hidden;
    }

    #pc-modal-header {
      padding: 18px 44px 14px 20px;
      border-bottom: 1px solid #eee;
    }
    #pc-modal-header h2 {
      font-size: 16px; font-weight: 700; color: #111; margin: 0 0 3px;
    }
    #pc-modal-header p {
      font-size: 12px; color: #888; margin: 0;
    }

    #pc-close {
      position: absolute; top: 14px; right: 14px;
      background: #f0f0f0; border: none;
      width: 30px; height: 30px; border-radius: 50%;
      font-size: 16px; cursor: pointer; color: #555;
      display: flex; align-items: center; justify-content: center;
      line-height: 1;
    }
    #pc-close:hover { background: #ddd; color: #111; }

    /* ── Table layout ─────────────────────────────────────────── */
    .pc-cmp-table {
      width: 100%; border-collapse: collapse; table-layout: fixed;
    }

    .pc-cmp-table td,  .pc-cmp-table th {
      border: 1px solid #e3e3e3;
      border-collapse: collapse;
    }

    /* Platform header row */
    .pc-cmp-table th.pc-th-label { width: 28%; }
    .pc-cmp-table th.pc-th-platform {
      width: 24%;
      padding: 14px 6px 12px;
      text-align: center; vertical-align: middle;
      border-bottom: 1px solid #e3e3e3;
    }
    .pc-cmp-table th.pc-th-hs { background: #f0fdf8; }
    .pc-cmp-table th.pc-th-amazon { background: #FFEED6; }
    .pc-cmp-table th.pc-th-flipkart { background: #E3E8FF; }

    .pc-logo-wrap { display: flex; flex-direction: column; align-items: center; gap: 5px; }
    .pc-logo-circle {
      width: 38px; height: 38px; border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      font-weight: 800; font-size: 15px; color: #fff; flex-shrink: 0;
    }
    .pc-logo-wrap img:first-child { height: 30px; object-fit: contain; }
    .pc-logo-wrap img:last-child { max-width: 70%; object-fit: contain; }

    .pc-th-hs .pc-logo-wrap img:first-child {height: 22px;  margin-bottom: 2px;}
    .pc-th-amazon .pc-logo-wrap img:first-child {height: 23px;}
    .pc-th-flipkart .pc-logo-wrap img:first-child {height: 19px; margin-bottom: 7px;}

     .pc-th-hs .pc-logo-wrap img:last-child {height: 9px;}
    .pc-th-amazon .pc-logo-wrap img:last-child {height: 10px;}
    .pc-th-flipkart .pc-logo-wrap img:last-child {height: 12px;}

    .pc-platform-label { font-size: 11px; font-weight: 600; color: #444; }

    /* Row label column */
    td.pc-row-label {
      padding: 12px 10px 12px 16px;
      font-size: 12px; color: #777; font-weight: 500;
      border-bottom: 1px solid ##e3e3e3;
      vertical-align: middle; line-height: 1.35;
    }

    /* Data cells */
    td.pc-cell {
      padding: 10px 6px;
      text-align: center; vertical-align: bottom;
      border-bottom: 1px solid ##e3e3e3;
    }
    td.pc-cell.pc-hs { background: #f6fef9; }
    td.pc-cell.pc-amazon { background: #FFEED6; }
    td.pc-cell.pc-flipkart { background: #E3E8FF; }
    .pc-cmp-table tr:last-child td { border-bottom: none; }

    /* Price cells */
    .pc-price-inner { display: flex; flex-direction: column; align-items: center; gap: 3px; }
    .pc-lpg {
      font-size: 7px; line-height:1.1; font-weight: 700; letter-spacing: 0.03em; text-transform: uppercase;
      background: #10b981; color: #fff;
      border-radius: 20px; padding: 2px 7px;
    }
    .pc-amt { font-size: 14px; font-weight: 700; color: #111; }
    .pc-amt.pc-best { color: #050606; }
.pc-na { color: #ccc; font-size: 13px; }

    /* Feature cells */
    .pc-feat { font-size: 13px; font-weight: 400; }
    .pc-feat-yes { color: #050606; }
    .pc-feat-no  { color: #050606; font-weight: 400; }
    .pc-feat-hs  { color: #050606; font-weight: 400; }



    .pc-loading { text-align: center; padding: 40px 0; color: #999; font-size: 14px; }
    .pc-error   { text-align: center; padding: 28px 0; color: #c00; font-size: 14px; }
  `;

  // ── Icons (inline SVG) ───────────────────────────────────────────────────
   const ICONS = {
    hearstore: `<img src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1784697150/assets/in/ecommerce/hearstore-icon.png" width="" height="" alt="HearStore"><img src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1784697150/assets/in/ecommerce/hearstore-text.png" width="" height="" alt="HearStore">`,
    amazon: `<img src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1784697150/assets/in/ecommerce/amazon-icon.png" width="" height="" alt="Amazon"><img src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1784697150/assets/in/ecommerce/amazon-text.png" width="" height="" alt="Amazon">`,
    flipkart: `<img src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1784697151/assets/in/ecommerce/flipkart-icon.png" width="" height="" alt="Flipkart"><img src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1784697151/assets/in/ecommerce/flipkart-text.png" width="" height="" alt="Flipkart">`,
  };

  function injectStyles() {
    const s = document.createElement('style');
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function buildModal() {
    const overlay = document.createElement('div');
    overlay.id = 'pc-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML = `
      <div id="pc-modal">
        <button id="pc-close" aria-label="Close">&times;</button>
        <div id="pc-modal-header">
          <h2>Price Comparison</h2>
          <p>Compare across platforms — updated regularly</p>
        </div>
        <div id="pc-content"><div class="pc-loading">Loading prices…</div></div>
      </div>
    `;
    document.body.appendChild(overlay);
    document.getElementById('pc-close').addEventListener('click', closeModal);
    overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });
  }

  function openModal()  { document.getElementById('pc-overlay').classList.add('pc-open');    document.body.style.overflow = 'hidden'; }
  function closeModal() { document.getElementById('pc-overlay').classList.remove('pc-open'); document.body.style.overflow = '';       }

  function fmt(price) {
    return '₹' + Number(price).toLocaleString('en-IN');
  }

  // Returns the best (lowest) one-ear price from a platform's data
  function getOneEarData(platformData) {
    const r = platformData?.right_ear;
    const l = platformData?.left_ear;
    // Only use an ear's price if it was actually scraped from its own URL
    const rHas = !!(r?.url && r?.price);
    const lHas = !!(l?.url && l?.price);
    if (rHas && lHas) return r.price <= l.price ? r : l;
    if (rHas) return r;
    if (lHas) return l;
    return { price: null, url: null };
  }

  function renderPriceCell(price, url, minPrice, platform) {
    const isHearstore = platform === 'hearstore';
    const platformCls = ` pc-${platform}`;
    if (!price) return `<td class="pc-cell${platformCls}"><span class="pc-na">—</span></td>`;

    const isBest = price === minPrice;
    const badge  = isHearstore && isBest ? `<span class="pc-lpg">Lowest Price Guarantee</span>` : '';

    return `<td class="pc-cell${platformCls}">
      <div class="pc-price-inner">
        ${badge}
        <span class="pc-amt${isBest ? ' pc-best' : ''}">${fmt(price)}</span>
      </div>
    </td>`;
  }

  function renderFeatureCell(value, platform) {
    const isHearstore = platform === 'hearstore';
    let cls = 'pc-feat';
    if (value === 'YES')       cls += ' pc-feat-yes';
    else if (value === 'NO')   cls += ' pc-feat-no';
    else if (isHearstore)      cls += ' pc-feat-hs';
    return `<td class="pc-cell pc-${platform}"><span class="${cls}">${value}</span></td>`;
  }

  function renderTable(product, shopifyPrices) {
    // shopifyPrices = { both_ears, right_ear, left_ear } from getShopifyVariantPrices()
    const oneEarAmazon    = getOneEarData(product?.amazon);
    const oneEarFlipkart  = getOneEarData(product?.flipkart);
    // Only use both_ears data if it was scraped from a dedicated both-ears URL
    const bothAmazon   = product?.amazon?.both_ears?.url   ? product.amazon.both_ears   : {};
    const bothFlipkart = product?.flipkart?.both_ears?.url ? product.flipkart.both_ears : {};

    // Best one-ear Shopify price (right or left, whichever is available/lower)
    const shopifyOneEar = shopifyPrices.right_ear && shopifyPrices.left_ear
      ? Math.min(shopifyPrices.right_ear, shopifyPrices.left_ear)
      : (shopifyPrices.right_ear || shopifyPrices.left_ear || null);
    const shopifyBothEars = shopifyPrices.both_ears;

    const hasOneEarRow   = !!(shopifyOneEar || oneEarAmazon.price || oneEarFlipkart.price);
    const hasBothEarsRow = !!(shopifyBothEars || bothAmazon.price || bothFlipkart.price);

    // Column header
    const thead = `<thead><tr>
      <th class="pc-th-label"></th>
      <th class="pc-th-platform pc-th-hs">
        <div class="pc-logo-wrap">
          ${ICONS.hearstore}
        </div>
      </th>
      <th class="pc-th-platform pc-th-amazon">
        <div class="pc-logo-wrap">
          ${ICONS.amazon}
        </div>
      </th>
      <th class="pc-th-platform pc-th-flipkart">
        <div class="pc-logo-wrap">
          ${ICONS.flipkart}
        </div>
      </th>
    </tr></thead>`;

    let rows = '';

    // Price (One Ear) row
    if (hasOneEarRow) {
      const prices = [shopifyOneEar, oneEarAmazon.price, oneEarFlipkart.price].filter(Boolean);
      const minPrice = prices.length ? Math.min(...prices) : null;
      rows += `<tr>
        <td class="pc-row-label">Price<br>(One Ear)</td>
        ${renderPriceCell(shopifyOneEar, null, minPrice, 'hearstore')}
        ${renderPriceCell(oneEarAmazon.price,   oneEarAmazon.url,   minPrice, 'amazon')}
        ${renderPriceCell(oneEarFlipkart.price, oneEarFlipkart.url, minPrice, 'flipkart')}
      </tr>`;
    }

    // Price (Both Ears) row
    if (hasBothEarsRow) {
      const prices = [shopifyBothEars, bothAmazon.price, bothFlipkart.price].filter(Boolean);
      const minPrice = prices.length ? Math.min(...prices) : null;
      rows += `<tr>
        <td class="pc-row-label">Price<br>(Both Ears)</td>
        ${renderPriceCell(shopifyBothEars, null, minPrice, 'hearstore')}
        ${renderPriceCell(bothAmazon.price,   bothAmazon.url,   minPrice, 'amazon')}
        ${renderPriceCell(bothFlipkart.price, bothFlipkart.url, minPrice, 'flipkart')}
      </tr>`;
    }

    // Feature rows
    FEATURE_ROWS.forEach(row => {
      rows += `<tr>
        <td class="pc-row-label">${row.label}</td>
        ${renderFeatureCell(row.hearstore, 'hearstore')}
        ${renderFeatureCell(row.amazon,   'amazon')}
        ${renderFeatureCell(row.flipkart, 'flipkart')}
      </tr>`;
    });

    return `<table class="pc-cmp-table">${thead}<tbody>${rows}</tbody></table>`;
  }

  function renderComparison(product, shopifyPrices) {
    const content = document.getElementById('pc-content');

    if (!product) {
      content.innerHTML = '<div class="pc-error">Price data not available for this product.</div>';
      return;
    }

    content.innerHTML = renderTable(product, shopifyPrices);
  }

  // Returns the current page price as a fallback
  function getShopifyPagePrice() {
    if (window.ShopifyAnalytics?.meta?.product?.variants?.[0]?.price) {
      return window.ShopifyAnalytics.meta.product.variants[0].price / 100;
    }
    const el = document.querySelector(
      '.price__regular .price-item--regular, .product__price .price, [class*="product-price"]'
    );
    if (el) {
      const num = parseFloat(el.textContent.replace(/[₹,\s]/g, ''));
      return isNaN(num) ? null : num;
    }
    return null;
  }

  // Returns { both_ears, right_ear, left_ear } Shopify prices.
  // If shopify_variants IDs are set → look up each variant's price from the page.
  // If not set (null) → fall back to the current page price (from shopify_handle).
  function getShopifyVariantPrices(shopifyVariants) {
    const allVariants = window.ShopifyAnalytics?.meta?.product?.variants
      || window.meta?.product?.variants
      || [];

    function priceForId(variantId) {
      if (!variantId) return null;
      const v = allVariants.find(v => String(v.id) === String(variantId));
      return v ? v.price / 100 : null;
    }

    const bothEars = priceForId(shopifyVariants?.both_ears);
    const rightEar = priceForId(shopifyVariants?.right_ear);
    const leftEar  = priceForId(shopifyVariants?.left_ear);

    // No variant IDs configured — fall back to the current page price for both rows
    const noVariantsSet = !shopifyVariants?.both_ears
      && !shopifyVariants?.right_ear
      && !shopifyVariants?.left_ear;

    if (noVariantsSet) {
      const pagePrice = getShopifyPagePrice();
      // Single page price — put it in both_ears only to avoid duplicating across both rows
      return { both_ears: pagePrice, right_ear: null, left_ear: null };
    }

    return { both_ears: bothEars, right_ear: rightEar, left_ear: leftEar };
  }

  function getCurrentHandle() {
    if (window.Shopify?.product?.handle) return window.Shopify.product.handle;
    if (window.ShopifyAnalytics?.meta?.product?.handle) return window.ShopifyAnalytics.meta.product.handle;
    const m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  async function fetchPrices() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (raw) {
        const { data, timestamp } = JSON.parse(raw);
        if (Date.now() - timestamp < CACHE_TTL) return data;
      }
    } catch {}

    const res = await fetch(WORKER_URL);
    if (!res.ok) throw new Error(`Worker ${res.status}`);
    const data = await res.json();

    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ data, timestamp: Date.now() })); } catch {}
    return data;
  }

  async function showComparison() {
    openModal();
    const content = document.getElementById('pc-content');
    const handle  = getCurrentHandle();

    if (!handle) {
      content.innerHTML = '<div class="pc-error">Open a product page to compare prices.</div>';
      return;
    }

    content.innerHTML = '<div class="pc-loading">Loading prices…</div>';

    try {
      const pricesData    = await fetchPrices();
      const product       = pricesData.products?.find(p => p.shopify_handle === handle);
      const shopifyPrices = getShopifyVariantPrices(product?.shopify_variants);
      renderComparison(product, shopifyPrices);
    } catch (err) {
      content.innerHTML = '<div class="pc-error">Could not load prices. Please try again.</div>';
      console.error('[PriceComparison]', err);
    }
  }

  function init() {
    if (!window.location.pathname.includes('/products/')) return;

    const handle = getCurrentHandle();
    if (!handle) return;

    injectStyles();
    buildModal();
    window.showPriceComparison = showComparison;

    // Wire up any pre-existing trigger button
    const trigger = document.querySelector('#price-comparison-trigger');
    if (trigger) {
      trigger.addEventListener('click', e => {
        e.preventDefault();
        showComparison();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'button_click',
          buttonId: 'comparePrices',
          buttonText: 'Compare Prices'
        });

        window.dataLayer.push({
          event: 'optimizely_event',
          optimizely_event_name: 'comparePrices'
        });
      });
    }

    // Silently check hearstore-products.json — show the trigger ONLY if this product has at least one real platform price
    fetchPrices().then(data => {
      const product = data?.products?.find(p => p.shopify_handle === handle);
      if (!product) return;

      const earTypes = ['both_ears', 'right_ear', 'left_ear'];
      const hasPrice = ['amazon', 'flipkart'].some(platform =>
        earTypes.some(ear => product?.[platform]?.[ear]?.price != null)
      );
      if (!hasPrice) return;

      if (trigger) {
        trigger.style.display = 'flex';
      }
    }).catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
